import * as React from 'react';
import cx from 'classnames';
import Timer, { Hours, Minutes, Seconds } from 'components/Timer/Timer';
import { stringTemplate } from 'components/StringWidget/StringWidget';
import { ExclamationIcon } from 'components/Icons/Icons';
import styles from './SLAItem.css';
import get from 'lodash/get';
const renderUrgency = (urgency, onTimerExpiry) => {
    if (!urgency) {
        return null;
    }
    let parts = urgency.text.split('{@expiryTime}');
    if (parts.length === 1) {
        return <span className={styles['sla-urgency']}>{parts[0]}</span>;
    }
    else if (parts.length > 1) {
        const timeRemaining = urgency.expiryTime * 1000 - new Date().valueOf();
        return (<span className={styles['sla-urgency']}>
				{parts[0]}
				<Timer timeRemaining={timeRemaining} onExpiry={onTimerExpiry}>
					<Hours padZeros suffix="h : "/>
					<Minutes padZeros suffix="m : "/>
					<Seconds padZeros suffix="s"/>
				</Timer>
				{parts[1]}
			</span>);
    }
    return null;
};
const renderPrices = (prices) => {
    return prices.map((price, index) => (<span className={cx(styles['price-value'], { [styles['strikeoff']]: price.strikeOff })} key={index}>
			{price.value === 0 ? <span className={styles['free-text']}>{stringTemplate('free')}</span> : `₹${price.value}`}
		</span>));
};
const SLAItem = ({ slaMessageConstruct, serviceable, prices = [], onTimerExpiry, urgency }) => {
    const slaLevel = get(slaMessageConstruct, ['level']);
    const slaText = get(slaMessageConstruct, ['text']);
    const pricesText = prices.length ? <React.Fragment> | {renderPrices(prices)}</React.Fragment> : null;
    return (<React.Fragment>
			{slaLevel === 'info' && (<div className={cx(styles['cart-item-sla'], { [styles['error']]: !serviceable })}>
					{slaText}
					{pricesText}
				</div>)}
			{slaLevel === 'warning' && (<div className={styles['cold-state-info']}>
					<ExclamationIcon className={styles['cold-state-info-icon']}/>
					<span className={styles['cold-state-info-text']}>
						{slaText}
						{pricesText}
					</span>
				</div>)}
			{renderUrgency(urgency, onTimerExpiry)}
		</React.Fragment>);
};
const SLAItemV4HOC = Component => (props) => {
    return <Component {...props} serviceable={true}/>;
};
export const SLAItemV4 = SLAItemV4HOC(SLAItem);
export default SLAItem;
